module.exports = __webpack_public_path__ + "img/PPMP3.109d7b77.png";